const pageNameKey = "nameOurNode";

export const nameOurNodeEn = {
  [pageNameKey]: {
    warningNoEmptyNodeName: "Node name cannot be empty",
    warningNoEmptyFolderName: "Folder name cannot be empty",
  },
};

export const nameOurNodePtBr = {
  [pageNameKey]: {
    warningNoEmptyNodeName: "O nome do nó não pode ficar vazio",
    warningNoEmptyFolderName: "O nome da pasta não pode ficar vazio",
  },
};

export const nameOurNodeDe = {
  [pageNameKey]: {
    warningNoEmptyNodeName: "Knotenname darf nicht leer sein",
    warningNoEmptyFolderName: "Verzeichnisname darf nicht leer sein",
  },
};

export const nameOurNodeZhHans = {
  [pageNameKey]: {
    warningNoEmptyNodeName: "节点名称不能为空",
    warningNoEmptyFolderName: "文件夹名称不能为空",
  },
};

export const nameOurNodeIt = {
  [pageNameKey]: {
    warningNoEmptyNodeName: "Il nome del nodo non può essere vuoto",
    warningNoEmptyFolderName: "Il nome della cartella non può essere vuoto.",
  },
};

export const nameOurNodeEs = {
  [pageNameKey]: {
    warningNoEmptyNodeName: "El nombre del nodo no puede estar vacío",
    warningNoEmptyFolderName: "El nombre de la carpeta no puede estar vacío",
  },
};

export const nameOurNodeNl = {
  [pageNameKey]: {
    warningNoEmptyFolderName: "Mapnaam mag niet leeg zijn",
    warningNoEmptyNodeName: "Nodenaam mag niet leeg zijn",
  },
};

export const nameOurNodeTr = {
  [pageNameKey]: {
    warningNoEmptyFolderName: "Klasör adı boş olamaz",
    warningNoEmptyNodeName: "Düğüm adı boş olamaz",
  },
};
